var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('FadeSlideUp',[_c('li',{class:[
			'flex flex-col list-none',
			_vm.center ? 'items-center' : 'items-start' ]},[_c('img',{staticStyle:{"height":"100px"},attrs:{"src":_vm.imgSrc,"alt":""}}),_vm._v(" "),_c('div',{class:[
				'mt-8 flex flex-wrap items-center',
				_vm.center && 'justify-center' ],staticStyle:{"column-gap":"10px","row-gap":"6px"}},[_c('h3',{class:[
					'font-header text-grey-700 font-semibold leading-tight text-pretty',
					_vm.center && 'text-center'
				],staticStyle:{"font-size":"28px"}},[_vm._v(_vm._s(_vm.title))]),_vm._v(" "),(_vm.$props.new)?_c('span',{staticClass:"py-1 px-3 bg-green rounded-full font-header font-bold leading-tight text-white uppercase",staticStyle:{"font-size":"13px"}},[_vm._v("New")]):_vm._e()]),_vm._v(" "),_c('p',{class:[
				'text-base leading-tight',
				_vm.center && 'text-center'
			],staticStyle:{"color":"#67615F","margin-top":"10px"}},[_vm._v(_vm._s(_vm.description))])])])}
var staticRenderFns = []

export { render, staticRenderFns }